import React from "react";
import { Collapse } from "antd";

import { useConfig } from "../../data/useConfig";
import { useFilters } from "../../data/useFilters";

import { HeaderContainer } from "./styles";
import LayoutOptions from "./LayoutOptions";
import SortOptions from "./SortOptions";

const { Panel } = Collapse;

const Header = () => {
  const { showResultsLayoutOptions } = useConfig();
  const { error, data: metaData } = useFilters();

  if (!metaData?.meta?.results_count || error) return null;

  return (
    <>
      {metaData?.meta?.anchors_applied?.length > 0 && (
        <Collapse style={{ margin: "3rem" }}>
          <Panel header="Âncoras aplicadas">
            <p style={{ padding: "2rem" }}>
              {metaData?.meta?.anchors_applied?.map((anchor) => (
                <span style={{ display: "block", marginLeft: "1rem" }}>
                  {anchor.name}
                </span>
              ))}
            </p>
          </Panel>
        </Collapse>
      )}

      <HeaderContainer layoutOptions={showResultsLayoutOptions}>
        <LayoutOptions />
        <SortOptions />
      </HeaderContainer>
    </>
  );
};

export default Header;
